export default class extends HTMLElement {
  connectedCallback () {
    this.id = `menu-active-${Math.random().toString(32).split('.')[1]}`

    requestAnimationFrame(() => {
      const disclosure = this.closest('.approved-sidebar .alicia-settings-disclosure[open]')
      const active = this.querySelector('a[aria-current="page"]')
      if (!disclosure || !active) return
      const scrollRegion = this.closest('.settings-navigation')
      const bounds = scrollRegion.getBoundingClientRect()
      const item = active.getBoundingClientRect()
      const summaryHeight = 0
      if (item.bottom > bounds.bottom || item.top < bounds.top + summaryHeight) {
        scrollRegion.scrollTop += item.top - bounds.top - summaryHeight - 8
      }
    })

    this.querySelectorAll('a').forEach((link) => {
      if (document.location.pathname.startsWith(link.pathname) && !link.getAttribute('href').startsWith('http')) {
        link.classList.add('bg-base-300')
      }
    })
  }
}
